import { combineReducers } from 'redux';

import filtersReducer from './ducks/filters';
import flatBuildsReducer from './ducks/flatBuilds';
import flatJobsReducer from './ducks/flatJobs';
import flatHeadlessJobsReducer from './ducks/flatHeadlessJobs';
import flatManualReducer from './ducks/flatManual';
import usersReducer from './ducks/users';

const reducers = {
  filters: filtersReducer,
  flatBuilds: flatBuildsReducer,
  flatManual: flatManualReducer,
  flatJobs: flatJobsReducer,
  flatHeadlessJobs: flatHeadlessJobsReducer,
  users: usersReducer,
};

export default combineReducers(reducers);
